
import listings from '~/pages/_state/events-weekend/index.vue'
export default listings
